import React from 'react';
import './Hero.css';

const Hero: React.FC = () => {
  return (
    <section className="hero">
      <div className="hero-container">
        <div className="hero-content">
                  <h1 className="hero-title">
                    GetStrandX
                  </h1>
          <p className="hero-subtitle">
            Roadside help and DIY car care — powered by your community
          </p>
          <p className="hero-description">
            Stuck on the road? Get fast help from nearby neighbors. Want to save money?
            Learn how to change your oil, fix a flat, and handle everyday car maintenance
            with step-by-step guides and hands-on teaching from experienced locals.
          </p>
          <div className="hero-prelaunch-notice">
            <p className="prelaunch-badge">🚀 Coming Soon - Join the Waitlist</p>
          </div>
          <div className="hero-buttons">
            <button className="btn-primary" onClick={() => document.getElementById('prelaunch-survey')?.scrollIntoView({ behavior: 'smooth' })}>
              Get Early Access
            </button>
            <button className="btn-secondary" onClick={() => document.getElementById('learn-diy')?.scrollIntoView({ behavior: 'smooth' })}>
              Learn DIY Skills
            </button>
          </div>
        </div>
        <div className="hero-visual">
          <div className="phone-mockup">
            <div className="phone-screen">
              <div className="app-demo">
                <div className="emergency-button">
                  <div className="emergency-icon">🚗</div>
                  <div className="emergency-text">Roadside Help</div>
                </div>
                <div className="services-grid">
                  <div className="service-item">🔧 Flat Tire</div>
                  <div className="service-item">🔋 Jumpstart</div>
                  <div className="service-item">⛽ Gas Delivery</div>
                  <div className="service-item">🔧 Lockout</div>
                </div>
                <div className="status-indicator">
                  <div className="status-dot"></div>
                  <span>Connected</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
